// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryList_container__-Hui_","categoryItem":"CategoryList_categoryItem__21t7d","inModal":"CategoryList_inModal__1tD3I"};